export default __webpack_public_path__ + "static/media/section3_bg.dd0a2c55.svg";